import React, {useState} from "react";
import {inject, observer} from "mobx-react";
// local
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {IconDownload, IconDocumentDalux} from "components/icons/index";
import {openNewTab} from "helpers/helper";
import {Info} from "components/Info";

const DownloadZip = inject("store")(
  observer(({store: {clientStore}, docs, linksView, revisionId, folderId, disabled}) => {
    const [link, setLink] = useState();
    const [loading, setLoading] = useState(false);

    // Dalux files are fetched one by one and streamed straight to the browser, no S3 link to keep
    const downloadDaluxZip = () => {
      setLoading(true);
      clientStore.downloadDaluxZIP(revisionId, folderId).finally(() => setLoading(false));
    };

    const getZipLink = async () => {
      setLoading(true);
      const files = docs.map((item) => ({
        name: item.name || item.File?.name,
        url: item.url,
      }));

      clientStore
        .downloadZIP(files, revisionId)
        .then((data) => {
          setLoading(false);
          setLink(data.Location);
          openNewTab(data.Location);
        })
        .finally(() => setLoading(false));
    };

    return (
      <React.Fragment>
        <ButtonTransparent
          icon={linksView ? <IconDocumentDalux /> : <IconDownload />}
          name=".zip"
          small
          disabled={disabled}
          onClick={() =>
            linksView ? downloadDaluxZip() : link ? openNewTab(link) : getZipLink()
          }
          loading={(linksView || !link) && loading}
          tooltip={linksView && "RFP_DOCUMENTS_DOWNLOAD_ZIP_DALUX"}
          addClass="mr-1 pl-1 pr-1"
          style={{width: loading && "70px"}}
        />

        {disabled && <Info tooltip="TOOLTIP_WAITING_FOR_ZIP_BUTTON" centerText />}
      </React.Fragment>
    );
  })
);

export default DownloadZip;
